export const HomeLivingNav=()=>{
  

    return(
      <div
      className="ddown"
      style={{
        marginLeft: "-200px",
      }}
    >
      <div className="flex">
        <div className="a1 h">
        <ul>
        <li>Bed Linen & Furnishing</li>
        <li>Bedsheets</li>
        <li>Bedding Sets</li>
        <li>Blankets, Quilts & Dohars</li>
        <li>Pillows & Pillow Covers</li>
        <li>Bed Covers</li>
      </ul>
  
      <ul className="nextul">
        <li>Flooring</li>
        <li>Carpets</li>
        <li>Floor Mats & Dhurries</li>
        <li>Door Mats</li>
      </ul>
        </div>
        <div className="a2 h">
        <ul>
        <li>Bath</li>
        <li>Bath Towels</li>
        <li>Hand & Face Towels</li>
        <li>Beach Towels</li>
        <li>Towels Set</li>
        <li>Bath Rugs</li>
        <li>Bath Robes</li>
        <li>Bathroom Accessories</li>
      </ul>
  
      <ul className="nextul">
        <li>Lamps & Lighting</li>
        <li>Floor Lamps</li>
        <li>Ceiling Lamps</li>
        <li>Table Lamps</li>
        <li>Wall Lamps</li>
        <li>Outdoor Lamps</li>
        <li>String Lights</li>
      </ul>
        </div>
        <div className="a1 h">
        <ul>
        <li>Home Decor</li>
        <li>Plants & Planters</li>
        <li>Aromas & Candles</li>
        <li>Clocks</li>
        <li>Mirrors</li>
        <li>WallDecor</li>
        <li>Wall Shelves</li>
        <li>Fountains</li>
        <li>Showpieces & Vases</li>
      </ul>
  
      <ul className="nextul">
        <li>Cushions & Cushion Covers</li>
      </ul>
  
      <ul className="nextul">
        <li>Curtains</li>
      </ul>
  
      <ul className="nextul">
        <li>Home Gift Sets</li>
      </ul>
        </div>
        <div className="a2 h">
        <ul>
        <li>Kitchen & Table</li>
        <li>Dinnerware & Serveware</li>
        <li>Cups and Mugs</li>
        <li>Bakeware & Cookware</li>
        <li>Kitchen Storage & Tools</li>
        <li>Bar & Drinkware</li>
        <li>Table Covers & Furnishings</li>
      </ul>
  
      <ul className="nextul">
        <li>Storage</li>
        <li>Organisers</li>
        <li>Hooks & Holders</li>
      </ul>
        </div>
        <div
          className="a1 h"
          style={{
            paddingRight: "25px",
          }}
        >
          <ul>
        <li>Brands</li>
        <li>Home Centre</li>
        <li>Spaces</li>
        <li>D'Decor</li>
        <li>Portico New York</li>
        <li>Pure Home & Living</li>
        <li>Swayam</li>
        <li>Raymond Home</li>
        <li>Maspar</li>
        <li>Corelle</li>
        <li>Trident</li>
        <li>Cortina</li>
        <li>Story@Home</li>
        <li>Random</li>
        <li>Ellementry</li>
        <li>ROMEE</li>
        <li>SEJ by Nisha Gupta</li>
      </ul>
        </div>
      </div>
    </div>
    )
  }